<template>
  <el-card style="width: 700px; margin: 100px auto">
    <div style="width: 400px; margin: 0 auto">
      <div
          style="
          padding: 20px 0;
          font-size: 30px;
          text-align: center;
          font-weight: bold;
          color: dodgerblue;
        "
      >
        郑州大学中国外交话语研究院
      </div>
      <el-form ref="formRef" :model="form" :rules="rules">
        <el-form-item label="username:" label-width="100px" prop="userName">
          <el-input v-model="form.userName"/>
        </el-form-item>



          <el-form-item label="realname:" label-width="100px" prop="realname">
              <el-input  v-model="form.realname" placeholder="请输入姓名"/>
          </el-form-item>

          <el-form-item label="permission:" label-width="100px" prop="permission">
              <el-radio-group v-model="form.permission">
<!--                  0表示teacher,1表示学生-->
                  <el-radio :label="0">teacher</el-radio>
                  <el-radio :label="1">student</el-radio>
              </el-radio-group>
          </el-form-item>

        <el-form-item label="email:" label-width="100px" prop="email">
          <el-input v-model="form.email" placeholder=""/>
        </el-form-item>



        <el-form-item label="telephone:" label-width="100px" prop="telephone">
          <el-input v-model.number="form.telephone" placeholder="请正确输入数字格式"/>
        </el-form-item>

        <el-form-item label="password:" label-width="100px" prop="userPassword">
          <el-input v-model="form.userPassword" placeholder="密码不得少于8位，且包含字母和数字" show-password/>
        </el-form-item>

        <el-form-item label="password:" label-width="100px" prop="conPassword">
          <el-input v-model="form.conPassword" placeholder="密码不得少于8位，且包含字母和数字" show-password/>

        </el-form-item>

        <div style="text-align: center">
          <el-button type="primary" @click="register">Register</el-button>
          <el-button type="primary" @click="goLogin">Back</el-button>
        </div>
      </el-form>
    </div>
  </el-card>
</template>

<script setup>
import {ref} from 'vue'
import {ElMessage} from 'element-plus'
import axios from '@/util/axios'
import router from "@/router"

const form = ref({
  userName: '',
    realname: '',
    permission:'',
  email: '',

  telephone: '',

  userPassword: '',
  conPassword: ''
})
const checkEmail = (rule, value, callback) => {
  const zzumailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.zzu)+/;//郑州大学机构邮箱
  const governmentMailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.gov)+/;//政府机构邮箱
    const eduMailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.edu)+/; //教育机构邮箱
    const deMailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.de)+/;//德国机构邮箱
    const usMailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.us)+/;//美国机构邮箱
    const cnMailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.cn)+/;//中国机构邮箱
    const jpMailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.jp)+/;//日本机构邮箱
  if (!value) {
    return callback(new Error('邮箱不能为空'))
  }
  setTimeout(() => {
    if (zzumailReg.test(value)) {
      callback()
    } else if(governmentMailReg.test(value)) {
        callback()
    } else if(eduMailReg.test(value)){
            callback()
    } else if(usMailReg.test(value)){
        callback()
    } else if(cnMailReg.test(value)){
        callback()
    } else if(jpMailReg.test(value)){
        callback()
    } else if(deMailReg.test(value)){
        callback()
    }
    else {
        // callback(new Error('您的邮箱格式必须是政府或机构'))
        callback()
    }
  }, 100)
}
const rules = ref({
  userName: [
    {required: true, message: '请输入用户名', trigger: 'blur'}
  ],
    realname: [ // 新增姓名的验证规则
        { required: true, message: '请输入姓名', trigger: 'blur' }
    ],
    permission: [ // 新增姓名的验证规则
        { required: true, message: '请选择身份', trigger: 'blur' }
    ],
  email: [
    { validator: checkEmail, trigger: ['blur'], required: true }
  ],

    telephone: [
        { type: 'number', message: '手机号必须为数字值', trigger: ['change', 'blur'] }
    ],

  userPassword: [
    {required: true, message: '请输入密码', trigger: 'blur'},
      {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
          message: '密码不得少于8位，且包含字母和数字',
          trigger: 'blur'
      }
  ],
  conPassword: [
    {required: true, message: '请确认密码', trigger: 'blur'},
      {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
          message: '密码不得少于8位，且包含字母和数字',
          trigger: 'blur'
      }
  ]
})
const formRef = ref(null)

const register = async () => {
  if (form.value.userPassword !== form.value.conPassword) {
    return ElMessage.error("两次密码输入不一致")
  }
  formRef.value.validate(async (valid) => {
    if (valid) { // 所有input里面均存在有效值
      try {
        let res = await axios.post("user/reg", form.value)
        let data = res.data

        if (data.code === 200) {

            console.log(form.value)

          ElMessage.success("注册成功")
        } else {
          ElMessage.error(data.msg)
        }
      } catch (err) {
        console.log("error:" + err)
        ElMessage.error("服务器出错，请联系管理员！")
      }
    } else {
      ElMessage.error("请仔细检查输入")
    }
  })
}

const goLogin = () => {
  router.replace("/login")
}


</script>

<style scoped>
.el-form-item__label {
  text-align: justify;
}
</style>